export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_POLICY_HINT =
  'At least 12 characters, including uppercase, lowercase, a number, and a special character.';

export function validatePasswordPolicy(value) {
  if (!value) return 'Password is required';
  if (value.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters`;
  }
  if (!/[A-Z]/.test(value)) return 'Must contain at least one uppercase letter';
  if (!/[a-z]/.test(value)) return 'Must contain at least one lowercase letter';
  if (!/\d/.test(value)) return 'Must contain at least one number';
  if (!/[^A-Za-z0-9]/.test(value)) return 'Must contain at least one special character';
  return true;
}

export function getPasswordPolicyErrorMessage(error, fallback = 'Something went wrong') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'object' && detail?.message) {
    return detail.message;
  }
  if (typeof detail === 'string' && detail) {
    return detail;
  }
  return error?.response?.data?.message || error?.message || fallback;
}
